module.exports = __webpack_public_path__ + "img/spoken_read_stop_disa.aca76df6.svg";